module.exports = __webpack_public_path__ + "img/hr-rock-huge-07.7cbbbda8.png";